import React from 'react';
import ICard from '../../../models/card-set/ICard';
import Card from '../card/card';
import styles from './card-set.module.scss';
import { ApplicationSettings } from '../../../models/settings';

export type CardSetProps = {
  cards: ICard[];
  appSettings?: ApplicationSettings;
  id?: string;
};

export default function CardSet({ cards, appSettings, id }: CardSetProps) {
  return (
    <div className={`${styles[`card-set`]} ${styles[`card-set-${cards.length}`]}`} id={id}>
      {cards?.map((card) => (
        <Card
          key={card.id}
          orientation={cards.length === 1 ? 'horizontal' : 'vertical'}
          aspectRatio={card.imageTransform}
          redirectToUrl={card.url}
          image={card.cardImage}
          richText={card.text}
          secondaryText={card.secondaryText}
          buttonProp={card.button}
          appSettings={appSettings}
        ></Card>
      ))}
    </div>
  );
}
